import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { InternetSpeedTestListModel, RoomsDetailsListModel } from '../../models/cc/computer-centre-models';

@Injectable({
  providedIn: 'root'
})
export class ComputerCentreService {

  private baseUrl = environment.apiUrl + '/api/CC'

  constructor(private http: HttpClient) { }

  GetInternetSpeedsCheck(): Observable<InternetSpeedTestListModel[]>{
    return this.http.get<InternetSpeedTestListModel[]>(`${this.baseUrl}/internet/speed`)
  }

  GetRoomDetailsList(): Observable<RoomsDetailsListModel[]>{
    return this.http.get<RoomsDetailsListModel[]>(`${this.baseUrl}/rooms/details`)
  }

  

}
